$( document ).ready(function() {

  
    $( window ).scroll(function() {
    var scrollcheck = $(window).scrollTop();
    if( scrollcheck > 0 ) { $('.header_bg').addClass('shown_scroll');}
    else { $('.header_bg').removeClass('shown_scroll'); }
    });

  
    $('.product_image_link1').eq(0).remove();
    
    $('#drop_account').hide();
	   
    $('.my_account').click(function(){
	   $('#drop_account').fadeIn();  
	   return false;
    });
    
    $('.close').click(function(){
	   $('#drop_account').fadeOut(); 
	   return false; 
    });
    
	$('div#all_product_img').magnificPopup({
		delegate: 'a', // child items selector, by clicking on it popup will open
		type: 'image',
		gallery:{enabled:true}
		// other options
	});


     $('.product .image').hover(
          function(){
	          var newone = $(this).find('.swappable').data('swap');
	          $(this).find('.swappable').attr('src', newone);
	          
          },
          function(){
	           var oldone = $(this).find('.swappable').data('original');
	          $(this).find('.swappable').attr('src', oldone);
     });
  
  $('#collection .caption').click(function(){
    console.log('caption cliclk');
	   newurl = $(this).find('#title_my_sec_detial').attr('href');  
	   window.location = newurl;
    });
  
  
    setTimeout(function(){
      
      var current_item = $('#product').attr('class');
      var current_family = current_item.substr(0,4);
      
      console.log(current_family);
      
      if (current_family == '1115'){
        selectValues = { "1115-0534": "White/Black/Red", "1115-0234": "White Python/White", "1115-0334" : "Black Python/Black", "1115-0434" : "Red Python/White" };
	
      }
      if (current_family == '0621'){
        selectValues = { "0621-0234": "White/White", "0621-0134": "Black/Black", "0621-0434" : "Black-White/White", "0621-0534" : "Red/Black/White" };
	
      }
      
      if (current_family == '0502'){
        selectValues = { "0502-0234": "White Leather/White", "0502-0134": "Black Leather/White", "0502-0534" : "Red Leather/White" };
	
      }
      
      
    $.each(selectValues, function(key, value) { 
      if ( key == current_item){
        console.log('current-' + current_item);
      }
      else {
      
        $('#product-select-option-0')
        .append($('<option>', { value : key })
        .text(value)); 
      }
    });
      
      console.log('added');
    }, 500);
    

  
 
   $(document).on('change','#product-select-option-0',function(){
     selected_id =  this.value;
       family_check = selected_id.substr(0,4);
       var current_item = $('#product').attr('class');
       var current_family = current_item.substr(0,4); 
       if( family_check != current_family){
         //console.log('dont do anything');  
       }
       else {
         url =   'http://store.article-number.com/products/' + selected_id;
         //alert(url);
         window.location = url  
       }
  });
  
  
  
});